<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-links">
        <div class="footer-column">
          <h3>Contact</h3>
          <ul>
            <li><a href="#">Email</a></li>
            <li><a href="#">Phone</a></li>
          </ul>
        </div>
        <div class="footer-column">
          <h3>Plans</h3>
          <ul>
            <li><a href="#">Basic</a></li>
            <li><a href="#">Pro</a></li>
            <li><a href="#">Premium</a></li>
          </ul>
        </div>
        <div class="footer-column">
          <h3>Support</h3>
          <ul>
            <li><a href="#">FAQ</a></li>
            <li><a href="#">Documentation</a></li>
            <li><a href="#">Contact Support</a></li>
          </ul>
        </div>
        <div class="footer-column">
          <h3>About</h3>
          <ul>
            <li><a href="#">Company</a></li>
            <li><a href="#">Team</a></li>
            <li><a href="#">Mission</a></li>
          </ul>
        </div>
      </div>
      <div class="copyright-text">
        <p>© {{new Date().getFullYear()}} Abhilasha Research and Technology LLP</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #081927;
  color: #fff;
  padding: 30px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.footer-links {
  display: flex;
  justify-content: space-between;
}

.footer-column {
  flex: 1;
}

.footer-column h3 {
  margin-bottom: 10px;
}

.footer-column ul {
  list-style-type: none;
  padding: 0;
}

.footer-column ul li {
  margin-bottom: 5px;
}

.footer-column ul li a {
  color: #ccc;
  text-decoration: none;
}

.footer-column ul li a:hover {
  color: #fff;
}

.copyright-text{
  margin-top:5%;
  font-size: 15px;
}

@media only screen and (max-width: 800px) {

.footer-links{
  display:none;
}

}

</style>
